import Alert from "react-bootstrap/Alert";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilm } from "@fortawesome/free-solid-svg-icons";

import { VideoResult } from "./videoResult";
import {
    TagWithVideoCountViewModel,
    ToggleVideoTagBindingModel,
    VideoLibraryApiClient, VideoViewModel,
    VideoViewModelPaginatedResultsViewModel
} from "../apiClient";
import { AppPagination } from "./appPagination";

type Props = {
    paginatedResults: VideoViewModelPaginatedResultsViewModel;
    apiClient: VideoLibraryApiClient;
    tags: TagWithVideoCountViewModel[];
    onVideoUpdate: () => void;
    onVideoToggleTag: (video: VideoViewModel, bindingModel: ToggleVideoTagBindingModel) => void;
    onPageChange: (page: number) => void;
    showPagination?: boolean;
    columns?: number;
}

const getColBreakpoints = (cols: number) => {
    switch (cols) {
        case 3:
            return { xl: 4, lg: 4, md: 6, sm: 12 };
        case 6:
            return { xxl: 2, xl: 3, lg: 4, md: 6, sm: 12 };
        case 4:
        default:
            return { xl: 3, lg: 4, md: 6, sm: 12 };
    }
};

export const VideoResults = ({
    paginatedResults,
    apiClient,
    tags,
    onVideoUpdate,
    onVideoToggleTag,
    onPageChange,
    showPagination = true,
    columns = 4,
}: Props) => {
    const colBreakpoints = getColBreakpoints(columns);

    return (
        <>
            {paginatedResults?.totalCount === 0 && (
                <Alert
                    variant="info"
                    className="d-flex flex-column align-items-center text-center gap-2 py-5 border-0 rounded-4"
                >
                    <FontAwesomeIcon icon={faFilm} size="2x" className="opacity-50" />
                    <span className="fs-5 fw-semibold">No videos found.</span>
                    <span className="small text-body-secondary">Try adjusting your filters or search criteria.</span>
                </Alert>
            )}

            {paginatedResults?.totalCount !== 0 && (
                <>
                    <Row className="g-3">
                        {paginatedResults?.results?.map((video) => (
                            <Col key={video.id} {...colBreakpoints}>
                                <VideoResult
                                    video={video}
                                    apiClient={apiClient!}
                                    onVideoUpdate={onVideoUpdate}
                                    onVideoToggleTag={(bindingModel) => onVideoToggleTag(video, bindingModel)}
                                    tags={tags}
                                />
                            </Col>
                        ))}
                    </Row>
                    {showPagination && (
                        <div className="p-3 d-flex justify-content-center">
                            <AppPagination
                                page={paginatedResults?.page!}
                                pageSize={paginatedResults?.pageSize!}
                                totalPages={paginatedResults?.totalPages!}
                                totalCount={paginatedResults?.totalCount!}
                                onPageChange={(page) => onPageChange(page)}
                            />
                        </div>
                    )}
                </>
            )}
        </>
    );
};